/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Wb_Management_ContextInputs */

const en_wb_management_context = /** @type {(inputs: Wb_Management_ContextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Monday team brief`)
};

const lv_wb_management_context = /** @type {(inputs: Wb_Management_ContextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pirmdienas komandas kopsavilkums`)
};

/**
* | output |
* | --- |
* | "Monday team brief" |
*
* @param {Wb_Management_ContextInputs} inputs
* @param {{ locale?: "en" | "lv" }} options
* @returns {LocalizedString}
*/
export const wb_management_context = /** @type {((inputs?: Wb_Management_ContextInputs, options?: { locale?: "en" | "lv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Wb_Management_ContextInputs, { locale?: "en" | "lv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "lv") return lv_wb_management_context(inputs)
	return en_wb_management_context(inputs)
});